import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";

import { IProjetosRepository } from "../../repositories/projetos_repository";
import { ProjetoRevisaoResumoLista } from "../../models/revisao_projeto_resumo_lista";
import { IGetAllProjetoRevisaoResumoUseCase } from "../../../presentation/useCases/read/get_all_projeto_revisao_resumo_use_case";

export class GetAllProjetoRevisaoResumoUseCase extends BasePaginatedUseCase<ProjetoRevisaoResumoLista> implements IGetAllProjetoRevisaoResumoUseCase {
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllProjetoRevisaoResumo(
    idProjeto?: number | null,
    idDisciplina?: number | null,

    page?: number,
    rowsPerPage?: number): Promise<void> {
    const response = await this.repository.getAllProjetoRevisaoResumo(idProjeto, idDisciplina, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
